var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.getTemplate,{tag:"component",attrs:{"company":_vm.company}})}
var staticRenderFns = []

export { render, staticRenderFns }